import React, { useEffect, useState } from "react";
import axios from "axios";

import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import { showMessage, getToken } from "../../Functionalities/Functions";
import FilterComponent from "../../CoreComponents/FilterComponent";
import FilterModalComponent from "../../CoreComponents/FilterModalComponent";
import { protocol } from "../../Functionalities/Config";
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import NoDataComponent from "../../CoreComponents/NoDataComponent";
import { ManageWallet } from "./WalletLogic";
import TransactionHistoryModal from "../../CoreComponents/TransactionHistoryModal";

// function Body({ bo, na, nu, ar, ob, ao }) {
function Body() {
  const [data, setData] = useState([]);
  const [totalWalletAmount, setTotalWalletAmount] = useState("");
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");
  const [loading, setLoading] = useState(true);
  const [filter, setfilter] = useState({
    user: "",
    timestamp: "",
  });
  const [ModalData, setModalData] = useState({});

  useEffect(() => {
    getData();
  }, []);

  let params = "user=" + filter.user + "&timestamp=" + filter.timestamp;
  // (is_franchise_admin) && `&franchise=${franchise.id}`

  const getData = () => {
    // showMessage("Loading customers", "info", "Loading", "bottom", "bottom-left", 0);
    let path = "/wallet/display/";
    let result = ManageWallet("", "get", params, path);

    result
      .then((result) => {
        if (result.data.Status) {
          setData(result.data.results);
          setLoading(false);
          setNext(result.data.next);
          setPrev(result.data.previous);
          setTotalWalletAmount(result.data.total_amount);
        } else {
          showMessage(
            result.data.Message,
            "danger",
            "Loading error",
            "top",
            "top-right",
            0
          );
          setLoading(false);
        }
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
      });
  };

  const handlePrev = () => {
    // alert("prev");
    var config = {
      method: "get",
      url: prev.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setData(response.data.results);
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleNext = () => {
    //alert("next")
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        setData(response.data.results);
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  return (
    <div>
      <div className="content-body">
        {!loading ? (
          <div className="container-fluid">
            <FilterComponent
              handleNext={handleNext}
              handlePrev={handlePrev}
              next={next}
              prev={prev}
              filterButtonName={"Filter"}
              TotalWallet={"Total Wallet Amount"}
              TotalWalletAmount={totalWalletAmount}
            />
            <FilterModalComponent
              heading={"Filter Wallets"}
              // searchItemValue={filter.search_text}
              // searchItemChange={(e) =>
              //     setfilter({
              //         ...filter,
              //         search_text: e.target.value,
              //     })
              // }
              clearFilter={(e) => {
                e.preventDefault();
                window.location.reload();
              }}
              submitFilter={(e) => {
                e.preventDefault();
                getData();
              }}
            >
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="text-black font-w600">User Id</label>
                  <input
                    type="text"
                    value={filter.is_branch_admin}
                    class="form-control form-control-lg  "
                    onChange={(e) =>
                      setfilter({
                        ...filter,
                        user: e.target.value,
                        timestamp: "",
                      })
                    }
                  />
                </div>
              </div>
              {/* <div className="col-lg-6">
                                    <div className="form-group">
                                        <label className="text-black font-w600">
                                            Time
                                        </label>
                                        <select
                                            value={filter.is_branch_admin}
                                            class="form-control form-control-lg  "
                                            onChange={(e) =>
                                                setfilter({
                                                    ...filter,
                                                    is_customer: '',
                                                    is_deliveryboy: '',
                                                    is_branch_admin: e.target.value,
                                                    is_manager: '',
                                                })
                                            }
                                        >
                                            <option value={""} id={""}>
                                                Not apply
                                            </option>
                                            <option value={"true"} id={"true"}>
                                                Yes
                                            </option>

                                        </select>
                                    </div>
                                </div> */}
            </FilterModalComponent>

            <div className="row">
              <div className="col-lg-12">
                <div className="table-responsive rounded card-table">
                  <div
                    id="example5_wrapper"
                    class="dataTables_wrapper no-footer"
                    style={{ height: "calc(100vh - 18rem)", minHeight: "35rem" }}
                  >
                    {data?.length ? (
                      <table
                        className="table border-no order-table mb-4 table-responsive-lg dataTablesCard"
                        id="example5"
                      >
                        <thead
                          style={{
                            position: "sticky",
                            top: "0",
                            background: "#ffe4c4",
                            zIndex: "1",
                          }}
                        >
                          <tr>
                            <th>WALLET ID</th>
                            <th>USER ID</th>
                            <th>AMOUNT</th>
                            <th>IS ACTIVATED</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody id="customers">
                          {data.map((item) => {
                            return (
                              <>
                                <tr className="btn-reveal-trigger">
                                  <td className="py-2">
                                    <h5 className="mb-0 fs--1">
                                      {" "}
                                      FDRWLT{item.id}
                                    </h5>
                                  </td>
                                  <td className="py-3">
                                    <a href={`/customerID/${item.user}`}>
                                      {item.user}
                                    </a>
                                  </td>

                                  <td className="py-2">{item.amount}</td>

                                  <td className="py-2">
                                    {item.is_activated ? "YES" : "NO"}
                                  </td>

                                  <td>
                                    {item.transactions.length >= 1 ? (
                                      <FilterComponent
                                        transactionButtonName={"Transactions"}
                                        PrimaryBtnFunc={() =>
                                          setModalData(item)
                                        }
                                      />
                                    ) : (
                                      <div className="card-header justify-content-end p-0">
                                        <div className="">
                                          <button
                                            type="button"
                                            className="btn btn-primary mb-1 btn-rounded"
                                            disabled
                                          >
                                            Transactions
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </td>
                                </tr>

                                <TransactionHistoryModal
                                  heading={"Wallets Transactions"}
                                >
                                  <>
                                    <div className="row justify-content-center">
                                      <div className="col-xl-3 col-xxl-4">
                                        <div
                                          style={{
                                            backgroundColor: "white",
                                            borderRadius: 20,
                                          }}
                                        >
                                          <div className="text-center">
                                            <h5 style={{ paddingTop: 20 }}>
                                              {" "}
                                              Wallet Balance ( User{" "}
                                              {ModalData.is_activated === true
                                                ? ""
                                                : "Not "}{" "}
                                              Recharged )
                                            </h5>
                                          </div>

                                          <div
                                            style={{
                                              backgroundColor: "white",
                                              borderRadius: 20,
                                            }}
                                          >
                                            <div className="widget-timeline-icon2 text-center">
                                              <h1>₹ {ModalData.amount}</h1>
                                              <br></br>
                                            </div>
                                          </div>
                                          <div className="row">
                                            <div className="col-lg-6">
                                              <div className="form-group">
                                                <div className="form-group text-center">
                                                  <p>
                                                    IN{" "}
                                                    <i className="fa fa-arrow-down text-success" />{" "}
                                                  </p>
                                                  <h4>
                                                    ₹ {ModalData.amount_in}
                                                  </h4>
                                                  <br></br>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-lg-6">
                                              <div className="form-group">
                                                <div className="form-group text-center">
                                                  <p>
                                                    <i className="fa fa-arrow-up text-danger" />{" "}
                                                    OUT
                                                  </p>
                                                  <h4>
                                                    ₹ {ModalData.amount_out}
                                                  </h4>
                                                  <br></br>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div className="text-center">
                                            {ModalData.amount != 0 && (
                                              <a
                                                href=""
                                                class="btn btn-primary text-center mb-2 "
                                                data-toggle="modal"
                                                data-target="#sendMessageModaldeduct"
                                              >
                                                {" "}
                                                Deduct Wallet Money{" "}
                                              </a>
                                            )}
                                          </div>
                                        </div>
                                        <br></br>
                                      </div>
                                    </div>

                                    <div className="col-xl-12 mt-4">
                                      <div className="card">
                                        <div
                                          style={{
                                            backgroundColor: "white",
                                            borderRadius: 20,
                                          }}
                                        >
                                          <div class="card-header border-0 pb-0">
                                            <h4 class="fs-20 font-w600">
                                              Wallet Transaction History
                                            </h4>
                                          </div>
                                          <div div class="card-body pb-0">
                                            <div class="widget-timeline-icon2">
                                              <ul class="timeline">
                                                {ModalData.transactions?.map(
                                                  (tran, index) => {
                                                    return (
                                                      <>
                                                        <li>
                                                          <div class="icon bg-primary" />
                                                          <a class="timeline-panel text-muted">
                                                            {/* <h4 class="mb-2 "> {tran.transaction_type}
                                                                                                        {index === 0 && <span onClick={() => setEditTransaction(tran)} style={{ color: "white", cursor: "pointer", fontSize: 13, padding: 3, backgroundColor: "#3fb049", borderRadius: 8, marginLeft: 5, }} data-toggle="modal" data-target="#sendMessageModal3" > Edit </span>}
                                                                                                    </h4> */}
                                                            <div>
                                                              <div className="d-flex">
                                                                <h6 class="fs-15 mb-0">
                                                                  {/* {<i class={`fa ${tran.amount_in>0?'fa-plus-circle':'fa-minus-circle'}`} aria-hidden="true" >{" "}</i>} */}
                                                                  {/* {tran.amount_in>0 ?tran.amount_in:tran.amount_out} */}
                                                                  <i className="fa fa-arrow-up text-success">
                                                                    ₹{" "}
                                                                    {
                                                                      tran.amount_in
                                                                    }
                                                                  </i>
                                                                  <br />
                                                                  <i className="fa fa-arrow-down text-danger">
                                                                    ₹{" "}
                                                                    {
                                                                      tran.amount_out
                                                                    }
                                                                  </i>
                                                                </h6>
                                                              </div>
                                                              <p className="fs-15 mb-0 ">
                                                                {new Date(
                                                                  tran.timestamp
                                                                ).toDateString() +
                                                                  " ( " +
                                                                  new Date(
                                                                    tran.timestamp
                                                                  )
                                                                    .toString()
                                                                    .slice(
                                                                      16,
                                                                      25
                                                                    ) +
                                                                  " )"}
                                                                {/* {new Date(tran.timestamp).toDateString() + " " + formatAMPM(new Date(tran.timestamp))} */}
                                                                <br />
                                                                {tran.amount_in >
                                                                0
                                                                  ? tran.amount_in_details
                                                                  : tran.amount_out_details}
                                                              </p>
                                                            </div>
                                                          </a>
                                                        </li>

                                                        {/* edit wallet transaction component */}
                                                        {/* <div className="modal fade" id="sendMessageModal3" >
                                                                                                <div className="modal-dialog modal-dialog-centered" role="document" >
                                                                                                    <div className="modal-content">
                                                                                                        <div className="modal-header">
                                                                                                            <h5 className="modal-title"> Edit Wallet transaction </h5>
                                                                                                            <button type="button" className="close" data-dismiss="modal" >
                                                                                                                <span>×</span>
                                                                                                            </button>
                                                                                                        </div>
                                                                                                        <div className="modal-body">
                                                                                                            <form>
                                                                                                                <div className="form-row">
                                                                                                                    <div className="form-group col-md-6">
                                                                                                                        <label> Current Amount </label>
                                                                                                                        <input type="number" value={editTransaction.amount_in} min={0} readOnly className="form-control" />
                                                                                                                    </div>
                                                                                                                    <div className="form-group col-md-6">
                                                                                                                        <label> Change New Amount </label>
                                                                                                                        <input type="number" onKeyDown={(evt) => ((evt.key === "e" || evt.key === "-") && evt.preventDefault()) || (evt.key === "E" && evt.preventDefault())}
                                                                                                                            onWheelCapture={(e) => { e.target.blur(); }}
                                                                                                                            className="form-control"
                                                                                                                            value={transactionData.amount}
                                                                                                                            onChange={(e) => { setTransactionData({ ...transactionData, wallet_id: wallet.id, transaction_id: editTransaction.id, amount: e.target.value, }); }}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <button type="submit" className="btn btn-primary" style={{ marginTop: 10, }}
                                                                                                                    onClick={(e) => {
                                                                                                                        let result = AddMoney(e, [transactionData,], "update", "");
                                                                                                                        result.then((result) => {
                                                                                                                            if (result.data.Status === true) {
                                                                                                                                showMessage("Money added", "success", "Success!", "top", "top-right", 0);
                                                                                                                                setTransactionData({ amount: "", });
                                                                                                                                window.location.reload();
                                                                                                                            } else {
                                                                                                                                showMessage(result.data.Error, "danger", "Error!", "top", "top-right", 0);
                                                                                                                            }
                                                                                                                        }
                                                                                                                        ).catch((err) => {
                                                                                                                            showMessage("Error", "danger", "Error!", "top", "top-right", 0);
                                                                                                                        });
                                                                                                                    }}
                                                                                                                >
                                                                                                                    Update
                                                                                                                </button>
                                                                                                            </form>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div> */}
                                                      </>
                                                    );
                                                  }
                                                )}
                                              </ul>
                                            </div>
                                          </div>
                                          {/* )} */}
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                </TransactionHistoryModal>
                              </>
                            );
                          })}
                        </tbody>
                      </table>
                    ) : (
                      <NoDataComponent data="Users" />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <LoadingComponent />
        )}
      </div>
    </div>
  );
}

function Wallet() {
  // const boln = true
  // const name = 'sgduk'
  // const num = 23
  // const ary = [1, 2, 3, 4]
  // const obj = { id: 1, name: "sar" }
  // const aryobj = [
  //     { id: 1, name: "sar" },
  //     { id: 2, name: "jas" },
  //     { id: 3, name: "suh" },
  //     { id: 4, name: "sha" }
  // ]
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={"Wallet"} subHeading={"All customers Wallet Reports"} />
        <NavBar />
        {/* <Body bo={boln} na={name} nu={num} ar={ary} ob={obj} ao={aryobj} /> */}
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default Wallet;
